import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';

import H1 from 'shared/app/components/h1';
import { configImagesUrlSelector } from 'shared/app/state/selectors/config';

import messages from './messages';

const PersonalInformationConfirmation = () => {
  const { formatMessage } = useIntl();

  const configImagesUrl = useSelector(configImagesUrlSelector);

  return (
    <React.Fragment>
      <Helmet title={formatMessage(messages.confirmationHeader)} />
      <ContentColumn className="py8" size="md">
        <div className="text-center">
          <img
            alt=""
            src={`${configImagesUrl}/personal-information/confirm-inbox.svg`}
            width="256px"
          />
          <H1 className="text-bold pt2 lg-pt6 pb2" size="lg">
            {formatMessage(messages.confirmationHeader)}
          </H1>
        </div>
        <div className="py2">{formatMessage(messages.confirmationContent)}</div>
      </ContentColumn>
    </React.Fragment>
  );
};

export default PersonalInformationConfirmation;
